<template>
        <div 
        :class="headerHasActive===true?'header_show header':'header'" 
        id="header" ref="header"
        @mouseover='headerover'
        @mouseleave="headerleave">
            <div class="header_main pubw">
                <div class="logo" @click="toHome">
                  <img class="logo" v-if="headerHasActive"src="@/assets/img/logowhite.png" />
                  <img class="logo" v-else src="@/assets/img/logowhite2.png" />
                  </div>
                <div class="nav">
                    <div class="head" v-if="email">
                      <div class="t">
                        <div class="name dynamicolor">{{$t('header.hello')}},{{email}}</div>
                        <div class="arrow">
                          <span class="el-icon-caret-bottom"></span>
                        </div>
                      </div>
                      <div class="menu_list">
                        <el-menu
                        default-active="0"
                        :default-openeds="defaulet"
                        :collapse-transition="false"
                        active-text-color="#000"
                        router
                       >
                        <el-submenu :index="item.id" v-for="item in menuList" :key="item.id">
                          <template slot="title">
                              <span @click="jump(item.path)" style="width: 100%;display: inline-block;">{{item.title}}</span>
                          </template>
                          <el-menu-item :index="'/'+subItem.path" v-for="subItem in item.children" :key="subItem.id">
                              <span>{{subItem.title}}</span>
                          </el-menu-item>
                        </el-submenu>
                        <div class="singOut">
                          <optionsButton title="登出"  icon="el-icon-right" :callback="()=>{this.alertShow = true}"/>
                        </div>
                      </el-menu>
                      </div>
                    </div>
                    <router-link class="login_btn fonth" to='/login' v-if="!email" ><span class="dynamicolor">{{$t("header.login")}}</span></router-link>
                    <button class="mail fonth" @click="mailNow">{{ $t("header.mail") }}</button>
                </div>
            </div>
            <!-- 弹出框 -->
            <Alert :title="$t('header.logout')" :text="$t('header.cancel')" :callback="singOut" :alertShow="alertShow"/>
        </div>
</template>

<script>
import Alert from '@/components/Alert'
import optionsButton from '@/components/optionButton'
export default {
  name:'NavHeader',
  components:{
    optionsButton,
    Alert
  },
  data(){
      return {
        // 默认展开
        defaulet:["0"],
        // 头部展示状态
        headerHasActive:true,
        // 头部菜单列表
        menuList:[
          {
            id:'0',
            title:'我的訂單',
            children:[
                {
                id:'1',
                title:'全部訂單',
                path:`order/${1}`
                },
                {
                  id:'2',
                  title:'待收件',
                  path:`order/${2}`
                },
                {
                  id:'3',
                  title:'己收件',
                  path:`order/${3}`
                },
                {
                  id:'4',
                  title:'運送中',
                  path:`order/${4}`
                },
                {
                  id:'5',
                  title:'己送達',
                  path:`order/${5}`
                }
            ]
          },
          {
            id:'1',
            title:'個人設置',
            path:"/settings",
          },
          {
            id:'2',
            title:'聯繫人',
            path:"/contacts"
          }
        ],
        // 邮箱信息
        email:window.sessionStorage.getItem("email") || null,
        // 控制弹出框是否展示
        alertShow:false
      }
    },
  // 生命周期==>挂载完毕  
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
    // 获取用户信息
    this.getUserInfo()
    
    if(this.$route.name == "Home"){
      document.querySelector(".dynamicolor").style.color = "#fff"
     }
  },
  methods: {
    // 获取用户信息
    async getUserInfo(){
      let res = await this.$http.get("app/user/getusercp")
    },
    // 监听鼠标移入头部
    headerover(){
      this.headerHasActive = true
    },
    // 监听鼠标移出头部
    headerleave(){
        // 页面滚动距顶部距离
        let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      if (scrollTop === 0) {
        this.headerHasActive = false
        return
      }
    },
    // 监听页面滑动
    handleScroll() {
      // 页面滚动距顶部距离
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // 在顶部时，需要去掉fixed
      if (scrollTop === 0) {
        this.headerHasActive = false
        return
      }
      // 鼠标向上滚动
      this.headerHasActive = true
    },
    // 监听点击登录
    login(){
    },
    // 监听点击立即寄件
    mailNow(){
      this.$router.push('/mail')
    },
    // 跳转首页
    toHome(){
      this.$router.push('/')
    },
    // 退出登录函数
    singOut(type){
          if(type){
            this.email = ''
            this.$router.push('/')
            window.sessionStorage.clear()
          }
          return this.alertShow = false
     },
    //  监听用户点击tab栏菜单
     jump(path){
       if(!path) return
       this.$router.push(path)
     }
  },
  // 生命周期==>销毁前
  beforeDestroy() {
    this.$bus.$off("getEmail")
    window.removeEventListener("scroll", this.handleScroll, true);
  },
  watch:{
    // 监视路由改变
    $route(value){
      if(this.$route.name == "Home"){
        document.querySelector(".dynamicolor").style.color = "#fff"
     }else{
        document.querySelector(".dynamicolor").style.color = "#000"
     }
    }
  },
}
</script>

<style  lang="less">
    .header{
        display: flex;
        justify-content: center;
        height: 64px;
        position: fixed;
        width: 100%;
        z-index: 9999;
        font-family:"Source Han Sans HK Regular";
        .header_main{
            display: flex;
            justify-content: space-between;
            align-items: center;
            .dynamicolor{
              color: #000;
            }
            .logo{
                width: 195px;
                height: 45px;
            }
            .logo:hover{
              cursor: pointer;
            }
            .nav{
                display: flex;
                align-items: center;
                height: 100%;
                .login_btn{
                font-weight: 545;
                margin-right: 30px;
                color: #111;  
                }
                .t{
                  display: flex;
                  align-items: center;
                  height: 100%;
                    color:#111;
                }
                .mail{
                    color: #fff;
                    background-color: #474f8f;
                }
                .head{
                  position: relative;
                  display: flex;
                  justify-content: space-between;
                  color: #fff;
                  margin-right: 25px;
                  height: 100%;
                  .arrow{
                    animation: arrowDown .6s forwards;
                  }
                  .menu_list{
                    width: 229px;
                    display: none;
                    position: absolute;
                    top: 64px;
                    box-shadow: 0px 1px 10px #ccc;
                    border-radius: 10px;
                    overflow: hidden;
                    .el-menu-item:focus, .el-menu-item:hover{
                      background-color: #f1efff;
                    }
                    .el-menu{
                      border-radius: 10px;
                      .el-menu-item{
                        font-weight: 580;
                      }
                      .el-submenu__title{
                        span{
                          font-family:"Source Han Sans HK Regular" ;
                          font-weight:600;
                        }
                        i{
                          display: none;
                        }
                      }
                    }
                    .singOut{
                      display: flex;
                      margin-bottom: 20px;
                      justify-content: center;
                        button{
                          width: 82%;
                          height: 39px;
                          font-size:15px;
                        }
                          span{
                            width: 20px;
                            height: 20px;
                            line-height: 20px;
                        }
                    }
                  }
                  .name{
                    margin-right: 10px;
                    font-size: 17px;
                  }
                  &:hover{
                    cursor: pointer;
                  }
                  &:hover .arrow{
                    animation: arrowUp .6s forwards;
                  }
                  &:hover .menu_list{
                    display: block;
                  }
                }
            }
        }
    }
    .header_show{
        background-color: #575d7e;
    }
    .header:hover{
        background-color: #575d7e;
    }
    .header_main .nav .mail{
      width: 85px;
      height: 35px;
      border: none;
      border-radius: 10px;
    }
    .header_main .nav .mail:hover{
      opacity: 0.8;
      cursor: pointer;
      background-color: #fff;
      color: #575d7e;
    }
    .header_show .login_btn,
    .header_show .nav .head .t{
        color: #fff !important;
    }
      /* 最大宽度768px 手机 */
    @media screen and (max-width: 768px){

    }
</style>
